import { isString } from '@motorway/motorway-tools/typeHelpers';

// eslint-disable-next-line import/no-extraneous-dependencies
const scrollIntoView = (element, options) => {
  if (!element) {
    return undefined;
  }
  const withOptions = ('scrollBehavior' in document.documentElement.style);
  if (element.getBoundingClientRect().top > 0) {
    return undefined;
  }
  if (withOptions) {
    return element.scrollIntoView?.(options);
  }
  return element.scrollIntoView?.();
};

// eslint-disable-next-line valid-typeof
const type = (v, expected) => typeof v === expected;
const isNull = v => v === null;
const isObject = v => !isNull(v) && type(v, 'object') && !Array.isArray(v);
const isEmptyString = v => v === '';
const isUndefined = v => v === undefined;
const isArray = v => Array.isArray(v);
const isEmptyArray = v => isArray(v) ? !v.length : false;
const isEmptyObject = v => isObject(v) ? !Object.keys(v).length : false;
const isEmpty = v => isEmptyString(v) || isNull(v) || isUndefined(v) || isEmptyArray(v) || isEmptyObject(v);
const isDOMElement = v => v instanceof HTMLElement;
const isFunction = v => type(v, 'function');
const isBoolean = v => type(v, 'boolean');
const canUseDOM = () => !!(typeof window !== 'undefined' && window.document && window.document.createElement);
const numberToCSSUnit = (number, unit = 'px') => `${number}${unit}`;
const getClassNameFromEvent = e => {
  const className = e?.target?.className;
  // check for string value as `document` will return undefined and SVGs return an object
  return isString(className) ? className : '';
};
const getNavigationIndexes = ({
  items = [],
  selectedIndex = 0
}) => {
  const lastIndex = items.length - 1;
  const prevIndex = selectedIndex === 0 ? lastIndex : selectedIndex - 1;
  const nextIndex = selectedIndex === lastIndex ? 0 : selectedIndex + 1;
  const isInvalidArgs = selectedIndex < 0 || selectedIndex > lastIndex || !items.length;
  return {
    nextIndex: isInvalidArgs ? NaN : nextIndex,
    prevIndex: isInvalidArgs ? NaN : prevIndex
  };
};

export { isEmpty as a, isEmptyString as b, isArray as c, isDOMElement as d, canUseDOM as e, getClassNameFromEvent as f, getNavigationIndexes as g, isBoolean as h, isFunction as i, numberToCSSUnit as n, scrollIntoView as s };
